import { FieldValues, useController, UseControllerProps } from 'react-hook-form'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../shadcn/Select'
import { ReactNode } from 'react'

export interface SelectOption {
  value: string
  label: string
}

export type ControlledSelectProps<T extends FieldValues> = UseControllerProps<T> & {
  className?: string
  label?: string
  placeholder?: string
  options: SelectOption[]
  children?: ReactNode
}

export function ControlledSelect<T extends FieldValues>({
  control,
  name,
  rules,
  defaultValue,
  className,
  label,
  placeholder,
  options,
  children,
}: ControlledSelectProps<T>) {
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  })

  const value = field.value ? field.value.toString() : null

  console.log(value, options)

  return (
    <div className={className}>
      <label className={label === undefined ? 'none' : ''}>{label}</label>
      <Select value={value} onValueChange={field.onChange}>
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {children
            ? children
            : options.map(option => (
                <SelectItem
                  key={option.value ? option.value.toString() : ''}
                  value={option.value ? option.value.toString() : null}>
                  {option.label}
                </SelectItem>
              ))}
        </SelectContent>
      </Select>
      {!!fieldState.error?.message && <span className={'text-red-500'}>{fieldState.error?.message}</span>}
    </div>
  )
}
